/**
 * Added/removed by InteriorPlacementValidationSystem depending if a drawer/wirebasket
 * is invalid placed with regards to market height rules
 */
class InvalidPlacedInteriorComponent {
    constructor() {
        this.typeId = InvalidPlacedInteriorComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return true;
    }
}
InvalidPlacedInteriorComponent.id = 2013;
export default InvalidPlacedInteriorComponent;
//# sourceMappingURL=InvalidPlacedInteriorComponent.js.map